module.exports = __webpack_public_path__ + "static/img/sustainability_program_02.d330f50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sustainability_program_02.jpg
// module id = JfVo
// module chunks = 0